import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Container from '@mui/material/Container'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import Loader from '../shared/components/Loader'
import { useDispatch } from 'react-redux'
import { loginService } from './../services/authService'
import { login } from './../shared/redux/userSlice'
import { toastMessage } from './../shared/components/Toast'
import { LOGO_URL } from '../utils/constant'

export default function Login() {
  const [loader, setLoader] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const dispatch = useDispatch()

  const handleSubmit = () => {
    if (email == '' || password == '') {
      toastMessage('Please enter all fields', 'error')
    } else {
      // Normalize: accept 5551234567, 15551234567, or +15551234567 -> +1XXXXXXXXXX
      const digits = email.replace(/\D/g, "")
      if (digits.replace(/^1/, "").length < 10) {
        setLoader(false)
        toastMessage('Enter a 10-digit phone number', 'error')
        return
      }
      setLoader(true)
      let obj = {
        phoneNumber: "+1" + digits.slice(-10),
        password:password
      }
      loginService(obj)
        .then(({ data }) => {
          setLoader(false)
          dispatch(login(data))
        })
        .catch((err) => {
          setLoader(false)
          toastMessage(err.response.data.message, 'error')
        })
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit()
    }
  }

  const changeTitle = () => {
    document.title = 'Integrity 1st Car Pros'
  }
  useEffect(() => {
    changeTitle()
  }, [])

  return (
    <div className="background">
      <Box
        height="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Card
          sx={{ width: '100%', maxWidth: '594px', minWidth: 0, mx: 2 }}
          className="cardContainer"
        >
          <CardContent>
            <Container
              sx={{
                width: '90%',
                paddingTop: '36px',
                paddingBottom: '36px',
              }}
              className="containerLogin"
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '5%',
                }}
              >
                <img
                  src={LOGO_URL}
                  alt="Integrity 1st Car Pros"
                  style={{ maxWidth: '100%', height: 'auto', maxHeight: '108px' }}
                />
              </div>

              <Typography
                sx={{
                  fontStyle: 'normal',
                  fontWeight: 600,
                  fontSize: 25,
                  lineHeight: '48px',
                  letterSpacing: '-0.5px',
                  color: '#11142D',
                }}
                className="heading"
                color="text.secondary"
                gutterBottom
              >
                Welcome!
              </Typography>

              <Typography
                sx={{
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  color: '#11142D',
                  marginTop: '20px',
                  marginBottom: '5px',
                }}
              >
                Phone Number
              </Typography>

              <TextField
                InputProps={{
                  style: {
                    borderRadius: '12px',
                    border: 'none',
                    backgroundColor: '#F8F8F9',
                    height: '56px',
                  },
                }}
                sx={{ width: '100%' }}
                placeholder="5551234567"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                onKeyDown={handleKeyDown}
              />
              <Typography
                sx={{
                  fontStyle: 'normal',
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  color: '#11142D',
                  marginTop: '20px',
                  marginBottom: '5px',
                }}
              >
                Password
              </Typography>

              <TextField
                InputProps={{
                  style: {
                    borderRadius: '12px',
                    border: 'none',
                    backgroundColor: '#F8F8F9',
                    height: '56px',
                  },
                  endAdornment: (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        height: '100%',
                      }}
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </Box>
                  ),
                }}
                sx={{ width: '100%' }}
                type={showPassword ? 'text' : 'password'}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <Button
                sx={{
                  backgroundColor: 'rgb(248, 61, 75)',
                  width: '100%',
                  textTransform: 'none',
                  height: '56px',
                  marginTop: '25px',
                  '&:hover': {
                    backgroundColor: 'rgb(21, 101, 192)',
                  },
                }}
                variant="contained"
                onClick={() => handleSubmit()}
              >
                {loader ? <Loader /> : 'Login'}
              </Button>
            </Container>
          </CardContent>
        </Card>
      </Box>
    </div>
  )
}
